import StateObserver from 'src/StateObserver';
import { getTutorialController } from 'src/game/tutorial/TutorialController';
import CareMenu from '../CareMenu';
import { LockableFooterButton } from './LockableFooterButton';

export class FooterCareButton extends LockableFooterButton {
  public careMenu: CareMenu | undefined;

  constructor() {
    super({ type: 'care' });
  }

  public setActive(isActive: boolean) {
    if (isActive && StateObserver.getState().care.currentCareAction) {
      return;
    }

    super.setActive(isActive);
    if (isActive) {
      this.careMenu = new CareMenu();

      void getTutorialController().handleEvent('careMenuOpened');

      this.careMenu?.once('Close', () => this.onClick());
      this.careMenu?.once('ForceClose', () => this.setActive(false));
      this.careMenu?.fadeIn(this.getSuperview()!);
    } else {
      this.careMenu?.fadeOut();
      void getTutorialController().handleEvent('careMenuClosed');
    }
  }
}
